<div
  class="product-subsection"
  *ngIf="product"
  [style.marginTop.px]="marginService.getCurrentMargin(margin)"
>
  <a
    [routerLink]="[
      '/' + urlTranslateService.routingTable.shop.product,
      product.productLink
    ]"
  >
    <app-single-product
      [product]="product"
      [height]="[308, 422, 442]"
      [width]="[294, 304, 304]"
    ></app-single-product>
  </a>
</div>
